<template>
  <Card class="pa-4">
    <FlexColumn>
      <Label size="h6" bold text="希望条件" />
      <FlexColumn class="properties">
        <template v-if="isSide">
          <FlexColumn v-if="hourlyWage">
            <FlexRow>
              <Label text="希望時間単価（副業）" />
            </FlexRow>
            <Label bold :text="hourlyWage" />
          </FlexColumn>
          <FlexColumn v-if="workingHoursWeek">
            <FlexRow>
              <Label text="希望勤務時間/週（副業）" />
            </FlexRow>
            <Label bold :text="workingHoursWeek" />
          </FlexColumn>
          <FlexColumn v-if="applicant.conditions.availabilityDaytime || applicant.conditions.availabilityEvening || applicant.conditions.availabilityHoliday">
            <FlexRow>
              <Label text="希望勤務時間帯（副業）" />
            </FlexRow>
            <FlexRow>
              <Label bold text="平日昼：" />
              <Label bold :text="availabilityTime(applicant.conditions.availabilityDaytime)" />
            </FlexRow>
            <FlexRow>
              <Label bold text="平日夜：" />
              <Label bold :text="availabilityTime(applicant.conditions.availabilityEvening)" />
            </FlexRow>
            <FlexRow>
              <Label bold text="土日祝：" />
              <Label bold :text="availabilityTime(applicant.conditions.availabilityHoliday)" />
            </FlexRow>
          </FlexColumn>
        </template>
        <FlexColumn v-if="prefectures">
          <Label text="希望勤務地" />
          <Label bold :text="prefectures" />
        </FlexColumn>
        <FlexColumn v-if="remote">
          <Label text="リモートワーク希望" />
          <Label bold :text="remote" />
        </FlexColumn>
        <FlexColumn v-if="applicant.conditions.environment">
          <Label text="今後やっていきたい・身を置きたい環境" />
          <TextView :text="applicant.conditions.environment" />
        </FlexColumn>
        <template v-if="!isSide">
          <FlexColumn v-if="applicant.conditions.resourceType || applicant.conditions.developmentType || applicant.conditions.companyScale || applicant.conditions.workingStance">
            <Label text="仕事の志向" />
            <FlexColumn :space="0" class="pl-2">
              <ResourceTypeSlider :value="applicant.conditions.resourceType" />
              <DevelopmentTypeSlider :value="applicant.conditions.developmentType" />
              <CompanyScaleSlider :value="applicant.conditions.companyScale" />
              <WorkingStanceSlider :value="applicant.conditions.workingStance" />
            </FlexColumn>
          </FlexColumn>
          <FlexColumn v-if="applicant.conditions.otherRequirements">
            <Label text="その他希望条件" />
            <TextView :text="applicant.conditions.otherRequirements" />
          </FlexColumn>
        </template>
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import FlexRow from "@/components/atoms/FlexRow";
import ResourceTypeSlider from "@/components/molecules/ResourceTypeSlider";
import DevelopmentTypeSlider from "@/components/molecules/DevelopmentTypeSlider";
import CompanyScaleSlider from "@/components/molecules/CompanyScaleSlider";
import WorkingStanceSlider from "@/components/molecules/WorkingStanceSlider";
import TextView from "@/components/atoms/TextView";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantConditionsCard",
  components: {
    TextView,
    WorkingStanceSlider, CompanyScaleSlider, DevelopmentTypeSlider, ResourceTypeSlider, FlexRow, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    },
    isSide: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    hourlyWage() {
      return this.constsToText(this.applicant.conditions.hourlyWage, this.consts.hourlyWedgeRange)
    },
    workingHoursWeek() {
      return this.constsToText(this.applicant.conditions.workingHoursWeek, this.consts.workingHoursRange)
    },
    availabilityTime() {
      const items = [
        { label: '実働可', value: 1 },
        { label: '連絡可', value: 2 },
        { label: '連絡不可', value: 3 },
      ]
      return (value) => {
        return this.constsToText(value, items)
      }
    },
    prefectures() {
      return this.applicant.conditions.prefectures.map(value => this.constsToText(value, this.consts.preferredLocation)).join("、")
    },
    remote() {
      return this.applicant.conditions.remoteWork ? 'フルリモートのみ' : 'なし'
    }
  }
}
</script>

<style scoped>
.properties > *:not(:last-child) {
  border-bottom: rgba(0, 0, 0, 0.12) solid thin;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
</style>